import { ReportTypeMap, SavedReport } from '../types'
import { GroupByValue } from '../types/groupByTypes'

const groupParamMap = {
  'facility.id': 'facility',
  'user.id': 'user',
  none: 'none',
} as const

export const fromGroupByParams = <RT extends keyof ReportTypeMap>(
  params?: Pick<SavedReport<RT>, 'groupColumn' | 'groupDateInterval'>,
): GroupByValue => {
  return {
    group: groupParamMap[params?.groupColumn ?? 'none'],
    interval: params?.groupDateInterval ?? 'none',
  }
}
